import { render, staticRenderFns } from "./SearchDictData.vue?vue&type=template&id=2308be9e&scoped=true&"
import script from "./SearchDictData.vue?vue&type=script&lang=js&"
export * from "./SearchDictData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308be9e",
  null
  
)

export default component.exports